/* eslint-disable react/jsx-one-expression-per-line */
import { Box, Button, Center, HStack, Stack, Text } from '@chakra-ui/core';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdArrowBack, MdHome } from 'react-icons/md';
import { useStoreActions } from '../models/hooks';

export default function Forbidden() {
  const { t } = useTranslation();
  const query = new URLSearchParams(useLocation().search);
  const isGuest = query.get('guest') === 'true';

  const signOut = useStoreActions((actions) => actions.auth.signOut);

  const handleSignOut = () => {
    // eslint-disable-next-line
    signOut()
      .then(() => window.location.replace('/'))
      .catch(console.error);
  };
  const handleGoBack = () => {
    window.history.back();
  };

  const backToHome = () => {
    window.location.replace('/');
  };

  return (
    <Center h="100vh" w="100%">
      <HStack>
        <ForbiddenImage />

        <Box flex="1 0 50%">
          <Stack maxW="60%" spacing={0}>
            <Text fontSize="md" textAlign="center" mb={1}>
              {t('app:forbidden:title')}
            </Text>

            <Text textAlign="center" fontSize="md">
              {t('app:forbidden:message')}
            </Text>

            <Stack marginTop="20px !important">
              {isGuest ? (
                <Button data-testid="sign-out-button" leftIcon={<MdArrowBack />} color="gray[100]" onClick={handleSignOut}>
                  {t('app:forbidden:signOut')}
                </Button>
              ) : (
                <>
                  <Button
                    data-testid="go-home-button"
                    leftIcon={<MdHome />}
                    variant="solid"
                    colorScheme="blue"
                    onClick={backToHome}
                  >
                    {t('app:forbidden:goHome')}
                  </Button>
                  <Button data-testid="go-back-button" leftIcon={<MdArrowBack />} color="gray[100]" onClick={handleGoBack}>
                    {t('app:forbidden:goBack')}
                  </Button>
                </>
              )}
            </Stack>
          </Stack>
        </Box>
      </HStack>
    </Center>
  );
}

const ForbiddenImage = () => {
  return (
    <svg
      width="963"
      height="686"
      viewBox="0 0 963 686"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: '100px' }}
    >
      <path
        d="M497.392 22.6094C521.01 25.7564 541.609 36.1164 559.185 53.6924C580.594 75.1017 591.298 100.995 591.298 131.37V175.286H613.257C625.334 175.286 635.672 179.586 644.272 188.187C650.283 194.197 654.19 201.058 656 208.767V449.223C654.19 456.931 650.283 463.792 644.272 469.803C636.394 477.681 627.057 481.948 616.262 482.609H481V372.905C481.169 372.907 481.338 372.911 481.507 372.911C493.584 372.911 503.922 368.611 512.522 360.011C521.123 351.41 525.423 341.072 525.423 328.995C525.423 316.918 521.123 306.579 512.522 297.979C503.922 289.378 493.584 285.078 481.507 285.078C481.338 285.078 481.169 285.081 481 285.083V175.286H547.382V131.37C547.382 113.072 540.977 97.517 528.168 84.708C515.359 71.8992 499.805 65.4952 481.507 65.4951C481.338 65.4951 481.169 65.496 481 65.4971V39.001C481 29.9481 488.339 22.6094 497.392 22.6094Z"
        fill="#2196F3"
        fillOpacity="0.1"
      />
      <mask id="mask0_9789_55328" maskUnits="userSpaceOnUse" x="218" y="0" width="527" height="527">
        <rect x="218" width="527" height="527" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9789_55328)">
        <g filter="url(#filter0_d_9789_55328)">
          <path
            d="M349.757 483.094C337.679 483.094 327.341 478.794 318.74 470.193C310.14 461.593 305.84 451.254 305.84 439.177V219.594C305.84 207.517 310.14 197.178 318.74 188.578C327.341 179.977 337.679 175.677 349.757 175.677H371.715V131.76C371.715 101.385 382.42 75.4922 403.829 54.0828C425.238 32.6734 451.131 21.9688 481.507 21.9688C511.882 21.9688 537.775 32.6734 559.184 54.0828C580.594 75.4922 591.298 101.385 591.298 131.76V175.677H613.257C625.334 175.677 635.672 179.977 644.273 188.578C652.873 197.178 657.173 207.517 657.173 219.594V439.177C657.173 451.254 652.873 461.593 644.273 470.193C635.672 478.794 625.334 483.094 613.257 483.094H349.757ZM481.507 373.302C493.584 373.302 503.922 369.002 512.523 360.402C521.123 351.801 525.423 341.463 525.423 329.385C525.423 317.308 521.123 306.97 512.523 298.369C503.922 289.769 493.584 285.469 481.507 285.469C469.429 285.469 459.091 289.769 450.49 298.369C441.89 306.97 437.59 317.308 437.59 329.385C437.59 341.463 441.89 351.801 450.49 360.402C459.091 369.002 469.429 373.302 481.507 373.302ZM415.632 175.677H547.382V131.76C547.382 113.462 540.977 97.908 528.168 85.099C515.359 72.2899 499.805 65.8854 481.507 65.8854C463.208 65.8854 447.654 72.2899 434.845 85.099C422.036 97.908 415.632 113.462 415.632 131.76V175.677Z"
            fill="#263DBA"
            fillOpacity="0.1"
            shapeRendering="crispEdges"
          />
          <path
            d="M481.507 22.4688C511.75 22.4688 537.516 33.1213 558.831 54.4365C580.146 75.7517 590.798 101.517 590.798 131.761V176.177H613.257C625.2 176.177 635.412 180.424 643.919 188.932C652.426 197.439 656.673 207.65 656.673 219.594V439.177C656.673 451.12 652.426 461.333 643.919 469.84C635.412 478.347 625.2 482.594 613.257 482.594H349.757C337.813 482.594 327.601 478.347 319.094 469.84C310.586 461.333 306.34 451.12 306.34 439.177V219.594C306.34 207.65 310.587 197.439 319.094 188.932C327.601 180.424 337.813 176.177 349.757 176.177H372.215V131.761C372.215 101.517 382.867 75.7518 404.183 54.4365C425.498 33.1213 451.263 22.4688 481.507 22.4688ZM481.507 284.969C469.296 284.969 458.83 289.322 450.137 298.016C441.443 306.709 437.09 317.175 437.09 329.386C437.09 341.596 441.444 352.062 450.137 360.755C458.83 369.448 469.296 373.802 481.507 373.802C493.717 373.802 504.183 369.448 512.876 360.755C521.569 352.062 525.923 341.596 525.923 329.386C525.923 317.175 521.569 306.709 512.876 298.016C504.183 289.322 493.717 284.969 481.507 284.969ZM481.507 65.3857C463.077 65.3857 447.395 71.8413 434.491 84.7451C421.587 97.649 415.132 113.331 415.132 131.761V176.177H547.882V131.761C547.882 113.331 541.425 97.649 528.521 84.7451C515.618 71.8414 499.936 65.3858 481.507 65.3857Z"
            stroke="#A0AEC0"
            shapeRendering="crispEdges"
          />
        </g>
        <path
          d="M559 176.109V130.109C559 87.3073 524.302 52.6094 481.5 52.6094V52.6094C438.698 52.6094 404 87.3073 404 130.109L404 176.109"
          stroke="#263DBA"
          strokeOpacity="0.1"
          strokeWidth="24"
        />
      </g>
      <path
        d="M397.213 187.967H565.787C571.783 187.967 576.643 192.827 576.643 198.822V452.252H386.357V198.822C386.357 192.827 391.217 187.967 397.213 187.967Z"
        fill="#263DBA"
        stroke="white"
        strokeWidth="2.71395"
      />
      <g filter="url(#filter1_d_9789_55328)">
        <path
          d="M372.781 454.609C372.781 450.191 376.363 446.609 380.781 446.609H581.898C586.316 446.609 589.898 450.191 589.898 454.609V475.106H372.781V454.609Z"
          fill="#F1F1F1"
        />
      </g>
      <mask id="mask1_9789_55328" maskUnits="userSpaceOnUse" x="440" y="292" width="83" height="82">
        <rect x="440.629" y="292.062" width="81.4186" height="81.4186" fill="white" />
      </mask>
      <g mask="url(#mask1_9789_55328)">
        <path
          d="M448.196 362.361C447.547 362.361 446.958 362.205 446.427 361.894C445.896 361.583 445.484 361.173 445.189 360.665C444.894 360.156 444.732 359.604 444.703 359.011C444.673 358.417 444.835 357.838 445.189 357.272L477.909 302.993C478.263 302.428 478.719 302.004 479.279 301.721C479.84 301.438 480.414 301.297 481.004 301.297C481.593 301.297 482.168 301.438 482.728 301.721C483.288 302.004 483.745 302.428 484.099 302.993L516.819 357.272C517.173 357.838 517.335 358.417 517.305 359.011C517.276 359.604 517.114 360.156 516.819 360.665C516.524 361.173 516.111 361.583 515.581 361.894C515.05 362.205 514.461 362.361 513.812 362.361H448.196ZM481.004 352.184C482.006 352.184 482.846 351.858 483.524 351.208C484.202 350.558 484.541 349.752 484.541 348.791C484.541 347.83 484.202 347.024 483.524 346.374C482.846 345.724 482.006 345.399 481.004 345.399C480.002 345.399 479.162 345.724 478.484 346.374C477.806 347.024 477.467 347.83 477.467 348.791C477.467 349.752 477.806 350.558 478.484 351.208C479.162 351.858 480.002 352.184 481.004 352.184ZM481.004 342.006C482.006 342.006 482.846 341.681 483.524 341.031C484.202 340.381 484.541 339.575 484.541 338.614V328.436C484.541 327.475 484.202 326.67 483.524 326.019C482.846 325.369 482.006 325.044 481.004 325.044C480.002 325.044 479.162 325.369 478.484 326.019C477.806 326.67 477.467 327.475 477.467 328.436V338.614C477.467 339.575 477.806 340.381 478.484 341.031C479.162 341.681 480.002 342.006 481.004 342.006Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter2_d_9789_55328)">
        <path
          d="M347 461.391C347 456.972 350.582 453.391 355 453.391H607.681C612.1 453.391 615.681 456.972 615.681 461.391V481.887H347V461.391Z"
          fill="white"
        />
      </g>
      <circle cx="561.401" cy="316.49" r="5.42791" fill="white" />
      <path d="M565.472 316.484H562.758" stroke="#263DBA" strokeWidth="1.35698" strokeLinecap="round" strokeLinejoin="round" />
      <g filter="url(#filter3_f_9789_55328)">
        <path d="M308.5 468.609H667.5L862.5 585.609H100L308.5 468.609Z" fill="#263DBA" fillOpacity="0.1" />
      </g>
      <defs>
        <filter
          id="filter0_d_9789_55328"
          x="273.84"
          y="-6.03125"
          width="415.332"
          height="525.125"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="16" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.14902 0 0 0 0 0.239216 0 0 0 0 0.729412 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9789_55328" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9789_55328" result="shape" />
        </filter>
        <filter
          id="filter1_d_9789_55328"
          x="371.781"
          y="444.609"
          width="219.117"
          height="30.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9789_55328" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9789_55328" result="shape" />
        </filter>
        <filter
          id="filter2_d_9789_55328"
          x="346"
          y="451.391"
          width="270.68"
          height="30.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9789_55328" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9789_55328" result="shape" />
        </filter>
        <filter
          id="filter3_f_9789_55328"
          x="0"
          y="368.609"
          width="962.5"
          height="317"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_9789_55328" />
        </filter>
      </defs>
    </svg>
  );
};
